import React from 'react';
import {
	makeStyles,
	Theme,
	FormControl,
	FormLabel,
	RadioGroup,
	FormControlLabel,
	Radio,
} from '@material-ui/core';
import { RadioButtonLayoutItem } from 'models/InputLayoutItem';
import { Control, FieldValues, Controller } from 'react-hook-form';

const useStyles = makeStyles((theme: Theme) => ({
	container: {
		marginTop: 24,
	},
	buttonsGroup: {
		marginTop: 8,
	},
}));

interface RadiobuttonProps extends RadioButtonLayoutItem {
	control: Control<FieldValues>;
	handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RadioButtonLayout = ({
	label,
	name,
	control,
	defaultValue,
	options,
	handleChange,
}: RadiobuttonProps) => {
	const classes = useStyles();

	return (
		<div>
			<Controller
				key={name}
				name={name}
				control={control}
				defaultValue={defaultValue}
				render={({ field }) => (
					<FormControl component="fieldset" className={classes.container}>
						<FormLabel component="legend" color="primary">
							{label}
						</FormLabel>
						<RadioGroup
							row
							className={classes.buttonsGroup}
							onChangeCapture={handleChange}
							{...field}
						>
							{options?.map((option, index) => (
								<FormControlLabel
									key={index}
									value={option.value}
									control={<Radio color="secondary" />}
									label={option.label}
								/>
							))}
						</RadioGroup>
					</FormControl>
				)}
			/>
		</div>
	);
};
